import React from "react";
import { Input as AntInput, InputProps, Input as Password } from "antd";
import styled from "styled-components";

interface CustomInputProps extends InputProps {
  error?: boolean;
}

const StyledInput = styled(AntInput)<CustomInputProps>`
  &.ant-input {
    height: 56px;
    border-radius: 4px;
    border: 2px solid var(--veloprime-text-secondary);
    background-color: var(--veloprime-bg-alternative);
    color: #000000;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 500;
    font-size: 16px;
    padding: 0 16px;
    
    &::placeholder {
      color: #666666;
    }
    
    &:hover {
      border-color: var(--veloprime-soft-gold);
    }
    
    &:focus {
      border-color: var(--veloprime-soft-gold);
      box-shadow: none;
    }
    
    &[disabled] {
      background-color: var(--veloprime-bg-alternative);
      color: var(--veloprime-text-secondary);
      cursor: not-allowed;
    }
    
    ${props => props.error && `
      border-color: var(--ant-error-color) !important;
      
      &:focus {
        border-color: var(--ant-error-color) !important;
      }
    `}
  }
  
  &.ant-input-affix-wrapper {
    height: 56px;
    border-radius: 4px;
    border: 2px solid var(--veloprime-text-secondary);
    background-color: var(--veloprime-bg-alternative);
    
    &:hover {
      border-color: var(--veloprime-soft-gold);
    }
    
    &:focus {
      border-color: var(--veloprime-soft-gold);
      box-shadow: none;
    }
    
    .ant-input {
      height: 52px;
      border: none;
      background: transparent;
      color: #000000;
      font-family: 'Nunito Sans', sans-serif;
      font-weight: 500;
      font-size: 16px;
      
      &::placeholder {
        color: #666666;
      }
    }
  }
`;

const StyledPassword = styled(Password)<CustomInputProps>`
  &.ant-input-affix-wrapper {
    height: 56px;
    border-radius: 4px;
    border: 2px solid var(--veloprime-text-secondary);
    background-color: var(--veloprime-bg-alternative);
    
    &:hover {
      border-color: var(--veloprime-soft-gold);
    }
    
    &:focus {
      border-color: var(--veloprime-soft-gold);
      box-shadow: none;
    }
    
    .ant-input {
      height: 52px;
      border: none;
      background: transparent;
      color: #000000 !important;
      font-family: 'Nunito Sans', sans-serif;
      font-weight: 500;
      font-size: 16px;
      
      &::placeholder {
        color: #666666 !important;
      }
    }
    
    .ant-input-suffix {
      color: var(--veloprime-text-secondary);
    }
  }
`;

const Input: React.FC<CustomInputProps> = (props) => {
  if (props.type === "password") {
    return <StyledPassword {...props} />;
  }
  
  return <StyledInput {...props} />;
};

export default Input;